export const normalizeSegment = (value = {}) => ({
  assortment_id: String(value.assortment_id || value.assortmentId || value.id_ms || value.id || '').trim(),
  type: String(value.type || value.type_ms || value.assortment_type || 'product').trim().toLowerCase(),
});

export const materialPathKey = (path = []) => path
  .map((segment) => {
    const normalized = normalizeSegment(segment);
    return `${normalized.type}:${normalized.assortment_id}`;
  })
  .join('/');

export function createMaterialNodes({
  materials,
  parentPath,
  parentKey = null,
  parentMultiplier = 1,
  depth = 0,
}) {
  const nodes = {};
  const keys = [];
  (Array.isArray(materials) ? materials : []).forEach((material) => {
    const segment = normalizeSegment(material);
    if (!segment.assortment_id) return;
    const path = [...parentPath.map(normalizeSegment), segment];
    const key = materialPathKey(path);
    const quantity = Number(material.quantity) || 0;
    if (nodes[key]) {
      nodes[key] = {
        ...nodes[key],
        quantity: nodes[key].quantity + quantity,
        multiplier: nodes[key].multiplier + (parentMultiplier * quantity),
      };
      return;
    }
    nodes[key] = {
      ...material,
      key,
      path,
      parentKey,
      depth,
      quantity,
      multiplier: parentMultiplier * quantity,
      selected: true,
      expanded: false,
      loading: false,
      error: '',
      childrenKeys: [],
    };
    keys.push(key);
  });
  return { nodes, keys };
}

export function isNodeActive(nodes, node) {
  let parentKey = node?.parentKey;
  while (parentKey) {
    const parent = nodes[parentKey];
    if (!parent?.expanded) return false;
    parentKey = parent.parentKey;
  }
  return true;
}

export function activeSelectedLeafKeys(nodes = {}) {
  return Object.values(nodes)
    .filter((node) => isNodeActive(nodes, node) && node.selected && !node.expanded)
    .map((node) => node.key);
}

export function buildDisassemblyDeclaration(nodes = {}) {
  const active = Object.values(nodes).filter((node) => isNodeActive(nodes, node));
  return {
    expanded_paths: active.filter((node) => node.expanded).map((node) => node.path),
    selected_paths: active.filter((node) => node.selected && !node.expanded).map((node) => node.path),
  };
}

export function expandedBranchesWithoutLeaves(nodes = {}) {
  const selected = new Set(activeSelectedLeafKeys(nodes));
  return Object.values(nodes)
    .filter((node) => isNodeActive(nodes, node) && node.expanded)
    .filter((node) => {
      const prefix = `${node.key}/`;
      return ![...selected].some((key) => key.startsWith(prefix));
    })
    .map((node) => node.key);
}
